import useHasPermissionUser from "@/composables/useHasPermissionUser";
import { RouteRecordRaw } from "vue-router";
import EditPage from "../EditPage.vue";
import IndexPage from "../IndexPage.vue";

export default {
  path: "hotels",
  children: [
    {
      path: "",
      name: "hotel.hotels",
      component: IndexPage,
    },
    {
      path: ":id",
      name: "hotels.hotel.edit",
      component: EditPage,
      beforeEnter: (to, from, next) => {
        const { hasPermissionUser } = useHasPermissionUser();

        if (hasPermissionUser("", "")) {
          next();
        } else {
          next({
            path: "/error/not-found",
          });
        }
      },
    },
  ],
} as RouteRecordRaw;
